import { AEMEarns } from '../models';

export const getEarnsTitle = (aem: AEMEarns | undefined): string => {
  return aem ? aem.title : '';
};
